import React from 'react';
import { Col, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { hexToRgb, processValue, getStatusHexColor } from '../Utils/generalUtil';
import CustomBootstrapIcon from '../../WSAControls/CustomBootstrapIcon/CustomBootstrapIcon';
import s from './SummaryTypeStyle2.module.scss';
import get from 'lodash.get';


const SummaryTypeStyle2 = ({ dashboardDetail }) => {

    const colorStatus = dashboardDetail.EvaluatedStatus ? getStatusHexColor(dashboardDetail.EvaluatedStatus) : dashboardDetail.ForeColor;

    const iconStyle = {
        backgroundColor: hexToRgb(colorStatus, 0.25),
        width: 'fit-content',
    }
    const processedValue = processValue(dashboardDetail.EvaluatedValue);
    return (
        <Card className={`${s.cardStyle} shadow mb-4 h-90 `}>
            <Card.Body className={`p-3`}>
                <div className="medium text-start d-flex align-items-center justify-content-between mt-1" style={{ minHeight: '50px' }}>
                    <span className='fs-5'>
                        {dashboardDetail.Title}{' '}
                        {dashboardDetail.ToolTip && (
                            <OverlayTrigger placement="top" overlay={<Tooltip>{dashboardDetail.ToolTip}</Tooltip>}>
                                <span style={{ cursor: 'pointer', color: 'rgba(255,255,255,0.65)', fontSize: '1.3em', lineHeight: 1 }}>&#9432;</span>
                            </OverlayTrigger>
                        )}
                    </span>
                    {/* <span>{getIcon(dashboardDetail.IconName)}</span> */}
                </div>
                {/* <div className=" bg-opacity-25 p-3 rounded-circle mb-2 mx-auto danger" style={iconStyle}>
                    <CustomBootstrapIcon icon={dashboardDetail.IconName} size={24} foreground={colorStatus} />
                </div> */}
                <div className="text-white mb-0  " style={{ fontSize: typeof processedValue ==='string' ? '3rem': '3rem', fontWeight: '300' }}>
                    {`${processedValue}`}
                    <span style={{fontSize:'1rem'}}>{processedValue != '-' ? dashboardDetail.UoM ?? '' : ''}</span>
                </div>

            </Card.Body>
        </Card>
    );
};
const getIcon = (iconName) => {
    switch (iconName) {
        case 'Clipboard2Pulse':
            return <svg viewBox="0 0 50 50" width="50" height="50">
                <path d="M10 25 L17.5 32.5 L40 10" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        case 'Water':
            return <svg viewBox="0 0 50 50" width="50" height="50">
                <path d="M25 10 C25 10, 35 20, 35 30 C35 36.5, 30.5 41, 25 41 C19.5 41, 15 36.5, 15 30 C15 20, 25 10, 25 10 Z"
                    fill="white"
                    stroke="none" />
            </svg>
        case 'ThermometerHalf':
            return <svg viewBox="0 0 50 50" width="50" height="50">
                <circle cx="25" cy="40" r="7" fill="none" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />

                <line x1="25" y1="10" x2="25" y2="33" stroke="white" strokeWidth="8" strokeLinecap="round" />
            </svg>


        default:
            return <svg viewBox="0 0 50 50" width="50" height="50">
                <path d="M18 18 C18 12, 22 8, 28 8 C34 8, 38 12, 38 18 C38 22, 35 24, 32 26 L25 30" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="25" cy="38" r="2.5" fill="white" />
            </svg>


    }
}




export default SummaryTypeStyle2;